import {
  Box,
  Container,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import Link from 'next/link';

type LinkSection = {
  type: 'links';
  title: string;
  data: Array<{
    href: string;
    label: string;
  }>;
};

type SocialSection = {
  type: 'social';
  title: string;
  data: Array<{
    icon: string;
    label: string;
    url: string;
  }>;
};

type Sections = LinkSection | SocialSection;

const INFORMASI_LINKS: LinkSection['data'] = [
  { href: 'https://sukandadjaya.com/', label: 'Tentang Sukanda Djaya' },
  {
    href: 'https://www.sukandaonelink.com/syarat&ketentuan',
    label: 'Syarat & Ketentuan',
  },
  {
    href: 'https://www.sukandaonelink.com/kebijakan-privasi',
    label: 'Kebijakan Privasi',
  },
  {
    href: 'https://www.sukandaonelink.com/hubungi-kami',
    label: 'Hubungi Kami',
  },
];

const AKSES_CEPAT_LINKS: LinkSection['data'] = [
  { href: '/login', label: 'Login' },
  { href: '/aktivasi', label: 'Aktivasi' },
];

export const SOCIAL_MEDIAS: SocialSection['data'] = [
  {
    label: 'Facebook',
    icon: '/images/facebook-round.svg',
    url: 'https://id-id.facebook.com/sukandadjayaofficial/',
  },
  {
    label: 'Instagram',
    icon: '/images/instagram-round.svg',
    url: 'https://www.instagram.com/sukandadjaya/?hl=id/',
  },
  {
    label: 'Youtube',
    icon: '/images/youtube-round.svg',
    url: 'https://youtube.com/channel/UChzO8UAYyIRgH0tUg6JQ-Ew/',
  },
  {
    label: 'Twitter',
    icon: '/images/twitter-round.svg',
    url: 'https://twitter.com/ptsukandadjaya/',
  },
  {
    label: 'LinkedIn',
    icon: '/images/linkedin-round.svg',
    url: 'https://id.linkedin.com/company/diamond-cold-storage',
  },
];

const FOOTER_SECTIONS: Sections[] = [
  { type: 'links', title: 'Informasi', data: INFORMASI_LINKS },
  { type: 'links', title: 'Akses Cepat', data: AKSES_CEPAT_LINKS },
  { type: 'social', title: 'Ikuti Kami', data: SOCIAL_MEDIAS },
];

function isLinkSection(section: Sections): section is LinkSection {
  return section.type === 'links';
}

export const PublicFooter = () => {
  return (
    <Box as="footer" bg="white">
      <Container maxW="1200px" py="8">
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={8}>
          <Box>
            <Image
              src="/images/sukanda_logo_LR.png"
              alt="Sukanda Onelink"
              h="40px"
              mb={4}
            />
          </Box>

          {FOOTER_SECTIONS.map((section, idx) => (
            <Stack key={idx} spacing="7">
              <Text fontWeight="bold" fontSize="lg">
                {section.title}
              </Text>
              {isLinkSection(section) ? (
                <Stack spacing="2">
                  {section.data.map((item) => (
                    <Text
                      as={Link}
                      key={item.href}
                      href={item.href}
                      color="#737B7D"
                      fontSize="md"
                    >
                      {item.label}
                    </Text>
                  ))}
                </Stack>
              ) : (
                <HStack>
                  {section.data.map((item, idx2) => (
                    <Link key={idx2} href={item.url} target="_blank">
                      <Image
                        boxSize="40px"
                        aria-label={item.label}
                        src={item.icon}
                      />
                    </Link>
                  ))}
                </HStack>
              )}
            </Stack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};
